import "./App.css";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { AuthPage } from "./routes/auth";
import { HelmetProvider } from "react-helmet-async";
import { HeadConfig } from "./Head";
import ProtectedRoutes from "./api/ProtectedRoutes";
import DayExercises from "./routes/dayExercises";
import SomethingWentWrong from "./routes/somethingWentWrong/SomethingWentWrong";
import { useEffect, useState } from "react";
import { LandingPage } from "./routes/landing";
import { PrivacyPolicy, SubscriptionPolicy, TermsOfUse } from "./routes/terms";

import { DATA } from "./routes/onboarding/default/stepper/questions/start/data";
import { usePreloadImages } from "./hooks/usePreloadImages";
import { Workouts } from "./routes/profile/workouts";
import { Workout } from "./routes/profile/workout";
import { Portal } from "./routes/auth/Portal";

import { Profile } from "./routes/profile/activeWorkout";
import { Somatic } from "./routes/onboarding/somatic";
import { EasyfitQuiz } from "./routes/onboarding/quiz";
import { Walky } from "./routes/onboarding/walky";
import { Easyfit } from "./routes/onboarding/default";
import { getFunnelType, WORKFLOW } from "./appConfig";
import { Paywall } from "./routes/containers/paywalls";
import { RoutesWithEmail } from "@api/RoutesWithEmail";
import { Loader } from "@common/loader";
import { WalkyProfile } from "./routes/walkyProfile";
import { Cookies } from "./routes/terms/Cookies";

const FUNNELS_MAP = {
  SOMATIC: Somatic,
  QUIZ: EasyfitQuiz,
  DEFAULT: Easyfit,
  WALKY_V1: Walky,
};

export const VERSION = {
  SOMATIC: "2.4",
  DEFAULT: "2.5",
  QUIZ: "2.3",
  WALKY_V1: "1.1",
};

function App() {
  const isWalky = WORKFLOW === "WALKY";

  usePreloadImages(DATA.map((item) => item.image));
  const funnelType = getFunnelType();
  const [isLoading, setIsLoading] = useState(true);

  // useEffect(() => {
  //   document.body.classList.toggle("is-walky", isWalky);
  // }, [isWalky]);

  useEffect(() => {
    const onLoad = () => setIsLoading(false);

    if (document.readyState === "complete") {
      setIsLoading(false);
    } else {
      window.addEventListener("load", onLoad);
    }

    return () => {
      window.removeEventListener("load", onLoad);
    };
  }, []);

  useEffect(() => {
    console.log(`${funnelType} web: ${VERSION[funnelType]}`);
  }, [funnelType]);

  if (isLoading) {
    return (
      <HelmetProvider>
        <HeadConfig />
        <Loader isWalky={isWalky} />
      </HelmetProvider>
    );
  }

  const CurrentApp = FUNNELS_MAP[funnelType] || FUNNELS_MAP.DEFAULT;

  return (
    <HelmetProvider>
      <HeadConfig />
      <BrowserRouter>
        <Routes>
          <Route path="/*" element={<CurrentApp />} />

          <Route element={<RoutesWithEmail />}>
            <Route element={<Paywall />} path="/paywall" />
          </Route>
          <Route element={<Portal />} path="/portal" />
          <Route element={<AuthPage />} path="/auth" />
          <Route element={<LandingPage />} path="/" />
          <Route element={<TermsOfUse />} path="/terms-of-use" />
          <Route element={<Cookies />} path="/cookies" />
          <Route element={<PrivacyPolicy />} path="/privacy-policy" />
          <Route element={<SubscriptionPolicy />} path="/subscription-policy" />
          <Route
            element={<SomethingWentWrong />}
            path="/something-went-wrong"
          />
          <Route element={<ProtectedRoutes />}>
            <Route element={<Profile />} path="/profile" />
            <Route element={<WalkyProfile />} path="/walky-profile" />
            <Route element={<Workouts />} path="/workouts" />
            <Route element={<Workout />} path={`/workouts/:title`} />
            <Route element={<DayExercises />} path="day-exercises/:id" />
            <Route
              element={<SomethingWentWrong />}
              path="/something-went-wrong"
            />
          </Route>
          <Route
            path="/onboarding"
            element={<Navigate to="/onboarding/1" replace />}
        />
        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
